import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { TlmMasterResponse } from "./useGetTlmMasterMutation";
import { TLM_MASTER_ACTIVE_LIST } from "../apiRoutes";
import axiosAuth from "../../axiosAuth";

const fetchActiveTlmMaster = async () => {
  const response = await axiosAuth.get(TLM_MASTER_ACTIVE_LIST);
  return response.data as TlmMasterResponse;
};

export const useGetActiveTlmMaster = (
  queryParams?: UseQueryOptions<TlmMasterResponse, Error, TlmMasterResponse, [string]>
) =>
  useQuery<TlmMasterResponse, Error, TlmMasterResponse, [string]>({
    queryKey: ["tlm-master-active"],
    queryFn: fetchActiveTlmMaster,
    ...(queryParams as any),
  });


